import React from 'react';
import { Button, Dialog } from '../../shared/ui';

/**
 * "Content exported", with the download behind a button.
 *
 * Replaces `shared/fileDownloadModal.html` and the `$modal.open` in
 * `navigationService.exportContent`. The export is built server-side and returned as a URL,
 * so all this does is show the result and follow the link.
 *
 * The failure case used to be a growl rather than a dialog. It is a dialog here because the
 * export is a menu click with no other feedback: a growl in the corner of a page the admin
 * may already have navigated away from is easy to miss, and there is no page to attach it to.
 */
const ExportContentDialog = ({ url, error, onClose }) => (
  <Dialog
    title={error ? 'Export failed' : 'Content exported'}
    onClose={onClose}
    footer={
      error ? (
        <Button onClick={onClose}>Close</Button>
      ) : (
        <Button
          variant="primary"
          onClick={() => {
            // `_self`, as the Angular version did. The server answers with
            // `Content-Disposition: attachment`, so this downloads rather than navigating.
            window.open(url, '_self');
            onClose();
          }}
        >
          Download
        </Button>
      )
    }
  >
    <p>{error || 'Content has been exported successfully.  Click the button below to download.'}</p>
  </Dialog>
);

export default ExportContentDialog;
